<mat-card appearance="outlined" class="payment-method"
  [class.payment-method--consent-needs-refresh]="paymentMethod.consentNeedsRefresh && !readOnly"
  [attr.aria-label]="paymentMethod.paymentMethodType + ' ending in ' + paymentMethod.last4Digits" role="region">
  @if (paymentMethod.consentNeedsRefresh && !readOnly && emailIsVerified) {
    <div class="accent-bar" role="status">
      <mat-icon svgIcon="attention" class="teller-online-icon"></mat-icon>
      <span class="accent-bar__text">
        Authorization Terms Updated
      </span>
      <button type="button" matButton
        (click)="onClick_reacknowledge()">
        Re-acknowledge
      </button>
    </div>
  }
  <mat-card-content>
    @if (paymentMethod.paymentMethodType === 'CreditCard') {
      <div class="credit">
        @if (isDefault && !readOnly) {
          <span class="payment-method__default status-badge status-badge--success">Default</span>
        }
        <div class="credit__header">
          @if (paymentMethodsService.getPaymentIcon(paymentMethod) === 'merchant-logos') {
            <mat-icon
              svgIcon="merchant-logos"
              class="credit__card-type merchant-logo"
              [ngClass]="paymentMethodsService.getMerchantLogoClass(paymentMethod.cardType)">
            </mat-icon>
          } @else {
            <mat-icon class="credit__card-type">
              {{ paymentMethodsService.getPaymentIcon(paymentMethod) }}
            </mat-icon>
          }
        </div>
        <span class="credit__number">
          **** {{paymentMethod.last4Digits}}
        </span>
        <div class="credit__footer">
          <span class="credit__name">
            {{paymentMethod.fullName}}
          </span>
          <span class="credit__expiry">
            {{paymentMethod.cardExpiry | parseExpiry}}
          </span>
        </div>
      </div>
    }

    @if (paymentMethod.paymentMethodType === 'ECheck') {
      <div class="echeck">
        @if (isDefault) {
          <span class="payment-method__default status-badge status-badge--success">Default</span>
        }
        <div class="echeck__header">
          <mat-icon class="echeck__icon">account_balance</mat-icon>
          <h3>E-Check</h3>
        </div>
        <div class="echeck__name">
          {{paymentMethod.fullName}}
        </div>
        <div class="echeck__fields">
          <div class="echeck-field">
            <mat-icon svgIcon="echeck-start" class="echeck-field__icon" aria-hidden="true"></mat-icon>
            <dl class="echeck-field__values">
              <dt>Routing number</dt>
              <dd>{{paymentMethod.eCheckRoutingNumber}}</dd>
            </dl>
          </div>
          <div class="echeck-field">
            <mat-icon svgIcon="echeck-start" class="echeck-field__icon" aria-hidden="true"></mat-icon>
            <dl class="echeck-field__values">
              <dt>Account number</dt>
              <dd>*****{{paymentMethod.last4Digits}}</dd>
            </dl>
          </div>
        </div>
      </div>
    }

    <div class="billing">
      <h3>Billing address</h3>

      <div class="billing__details">
        <div class="billing__address">
          <span>
            {{paymentMethod.addressLine1}}@if (paymentMethod.addressLine1 && paymentMethod.addressLine2) {
            <br>
            }{{paymentMethod.addressLine2}}
          </span>

          <span>
            {{paymentMethod.addressCity}}@if (paymentMethod.addressCity && (paymentMethod.addressState || paymentMethod.addressCountry)) {
            <span>,</span>
          }
          {{paymentMethod.addressState}}@if (paymentMethod.addressState && paymentMethod.addressCountry) {
          <span>,</span>
        }
        {{paymentMethod.addressCountry}}
      </span>

      <span>
        {{paymentMethod.addressZip}}
      </span>
    </div>

    <span>
      {{isNorthAmerica() ? (paymentMethod.phone | usaPhone:false) : paymentMethod.phone}}
    </span>
  </div>
</div>
</mat-card-content>
@if (!readOnly) {
  <mat-card-actions>
    @if (emailIsVerified) {
      @if (!isDefault) {
        <button type="button"
          class="make-default"
          matButton
          (click)="onChange_setDefault(paymentMethod)">
          <mat-icon class="icon-outlined">check_circle</mat-icon>
          Make Default
        </button>
      }
      <button type="button"
        matButton
        (click)="onClick_removeMethod($event, paymentMethod)" >
        <mat-icon>delete</mat-icon>
        Remove
      </button>
      <a href="#" [routerLink]="['/profile/payment-methods/'+paymentMethod.paymentMethodId]"
        matButton>
        <mat-icon>edit</mat-icon>
        Edit
      </a>
    }
  </mat-card-actions>
}
</mat-card>
